module.exports = __webpack_public_path__ + "img/28.883a98a3.jpg";